import { FaMinusCircle, FaPlusCircle } from "react-icons/fa";
import ConfirmationModal from "../../../TransactionPrivee/ConfirmTransaction/ConfirmationModal";

const TransferSecurityConfirmationModal = ({
  show,
  onHide,
  onConfirm,
  operationType = 'add', // 'add' ou 'remove'
  quantity,
  securityName,
  accountName,
  isLoading = false
}) => {
  const isAdd = operationType === 'add';
  const title = <span className="text text-white mb-1 text-center p-1 pb-1">Confirmation de {isAdd ? "l'ajout" : "du retrait"}</span>
  
  const getTransferMessage = () => {
    const operationText = isAdd ? 'ajouter' : 'retirer';
    const directionText = isAdd ? 'au compte' : 'du compte';
    
    let message = `Vous êtes sur le point de ${operationText} des titres.`;
    message += `\n\nQuantité : ${quantity} unités`;
    
    if (securityName) {
      message += `\nTitre : ${securityName}`;
    }
    
    if (accountName) {
      message += `\n${directionText} : ${accountName}`;
    }
    
    return message;
  };

  const getConfirmText = () => {
    return isAdd ? 'Confirmer l\'ajout' : 'Confirmer le retrait';
  };

  return (
    <ConfirmationModal
      show={show}
      onHide={onHide}
      onConfirm={onConfirm}
      title={title}
      message={getTransferMessage()}
      confirmText={getConfirmText()}
      cancelText="Annuler"
      variant={isAdd ? "warning" : "danger"}
      isLoading={isLoading}
      requiresAcknowledgment={true}
      acknowledgmentText={
        isAdd 
          ? "Je confirme l'ajout de ces titres et comprends que cette opération est irréversible"
          : "Je confirme le retrait de ces titres et comprends que cette opération est irréversible"
      }
      additionalInfo={
        isAdd 
          ? "L'ajout de titres augmentera le portefeuille du compte. Cette action est définitive."
          : "Le retrait de titres diminuera le portefeuille du compte. Cette action est définitive."
      }
      showCloseButton={!isLoading}
      confirmButtonVariant={isAdd ? "primary" : "danger"}
      confirmButtonIcon={isAdd ? <FaPlusCircle className="me-2" /> : <FaMinusCircle className="me-2" />}
      showOperationIcons={true}
      operationType={operationType}
    />
  );
};

export default TransferSecurityConfirmationModal;